import './style.scss';
import { InstructorSearchResultProfile } from '../../server/types';
import AppSearchResultProfile from '../../components/app_searchResultProfile/AppSearchResultProfile';

interface AppSearchResultRowProps {
	label: string,
	profiles: InstructorSearchResultProfile[]
}

function AppSearchResultRow({label, profiles}: AppSearchResultRowProps) {
	return (
		<>
			<div className='app-explore-result-row-label'>
				{label}
				<img
					className='app-explore-result-row-label-arrow'
					src='/imgs/icons/explore/icon-title-arrow.svg'
					alt='title arrow'
				/>
			</div>
			<div className='app-explore-result-row'>
				<div className="app-explore-result-row-wrap">
					{profiles?.map((profile: InstructorSearchResultProfile, index: number) => 
						<AppSearchResultProfile 
							profile={profile} 
							key={`profile-row${index}`}
						/>
					)}
				</div>
			</div>
		</>
	)
}

export default AppSearchResultRow
